import React from 'react';
import * as S from './InvoiceRow.styles';
import { DownloadIcon, SmallChevronIcon } from '@/components/UI/Icons/Icons';
import { Invoice } from '@/features/Profile/sections/Invoices/Invoices.types';
import { InvoiceStatusBadge } from '@/features/Profile/sections/Invoices/components/InvoiceStatusBadge';

interface InvoiceRowProps {
  invoice: Invoice;
  onShowDetails: (invoice: Invoice) => void;
}

export const InvoiceRow = ({ invoice, onShowDetails }: InvoiceRowProps) => {
  const {
    number,
    service,
    formattedAmount,
    status,
    statusDate,
    printUrl,
    canDownload,
  } = invoice;

  function handleDownloadClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.stopPropagation();
  }

  return (
    <S.Row onClick={() => onShowDetails(invoice)}>
      <S.Cell title={invoice.createdDate}>{invoice.createdDate}</S.Cell>
      <S.Cell title={number}>{number}</S.Cell>
      <S.Cell title={service}>{service}</S.Cell>
      <S.Amount>{formattedAmount}</S.Amount>
      <S.Cell title={statusDate}>{statusDate}</S.Cell>
      <S.StatusCell>
        <InvoiceStatusBadge status={status} />
      </S.StatusCell>

      <S.DownloadCell>
        {canDownload && (
          <S.Download
            href={printUrl}
            target="_blank"
            onClick={handleDownloadClick}
          >
            <DownloadIcon width={20} height={20} />
          </S.Download>
        )}
      </S.DownloadCell>

      <S.ChevronCell>
        <SmallChevronIcon width={10} height={12} />
      </S.ChevronCell>
    </S.Row>
  );
};
